// extracted by mini-css-extract-plugin
export var avatarContainer = "_h7-0";
export var avatarTypingWave = "_h7-i";
export var gray = "_h7-f";
export var green = "_h7-c";
export var icon = "_h7-9";
export var image = "_h7-1";
export var lg = "_h7-6";
export var md = "_h7-5";
export var presenceDot = "_h7-b";
export var red = "_h7-d";
export var sm = "_h7-4";
export var status = "_h7-a";
export var typingDot = "_h7-h";
export var typingPill = "_h7-g";
export var xl = "_h7-7";
export var xs = "_h7-3";
export var xxl = "_h7-8";
export var xxs = "_h7-2";
export var yellow = "_h7-e";